import React from 'react';
import ProjectRows from './ProjectRows.jsx';
import SessionListLoadingSkeleton from './SessionListLoadingSkeleton.jsx';

/** Compose canonical Project rows with independent sidebar browsing projections. */
export default function SessionListProjectSection({
  activeProjectId,
  sidebarNavigation, activeSessionId, loadingSessionId, runningSessionIds,
  onSelectSession, onRenameSession, onArchiveSession, onPinSession,
  createSessionInProjectLabel,
  onArchiveProject,
  onPinProject,
  onCreateSession,
  onLoadMoreProjects,
  onProjectSelect,
  paneCompact,
  projectContinuationKey,
  collectionScopeKey,
  projectError,
  projectHasMore,
  projectItems,
  projectLoading,
  projectLoadingMore,
  projectSlot,
  scrollElement,
  themeTokens,
}) {
  return (
    <div aria-busy={projectLoading} style={{ minHeight: '100%', width: '100%' }}>
      {projectLoading ? <SessionListLoadingSkeleton /> : (
        <ProjectRows
          sidebarNavigation={sidebarNavigation}
          activeSessionId={activeSessionId}
          loadingSessionId={loadingSessionId}
          runningSessionIds={runningSessionIds}
          onSelectSession={onSelectSession}
          onRenameSession={onRenameSession}
          onArchiveSession={onArchiveSession}
          onPinSession={onPinSession}
          activeProjectId={activeProjectId}
          createSessionInProjectLabel={createSessionInProjectLabel}
          onArchiveProject={onArchiveProject}
          onPinProject={onPinProject}
          onCreateSession={onCreateSession}
          onLoadMoreProjects={onLoadMoreProjects}
          onProjectSelect={onProjectSelect}
          paneCompact={paneCompact}
          projectContinuationKey={projectContinuationKey}
          collectionScopeKey={collectionScopeKey}
          projectError={projectError}
          projectHasMore={projectHasMore}
          projectItems={projectItems}
          projectLoadingMore={projectLoadingMore}
          projectSlot={projectSlot}
          scrollElement={scrollElement}
          themeTokens={themeTokens}
        />
      )}
    </div>
  );
}
